import { Flex } from 'foundations-components/components/Flex';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { invoiceStatusToStatusDotUse, invoiceStatusToStatusDotMessage, subscriptionDisplayStatusToStatusDotUse, subscriptionDisplayStatusToStatusBadgeMessage, commercePaymentStatusToStatusDotUse, commercePaymentStatusToMessage } from '../utils/typeAdapters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STATUS_MAPS = {
  invoice: {
    useMap: invoiceStatusToStatusDotUse,
    messageMap: invoiceStatusToStatusDotMessage
  },
  subscription: {
    useMap: subscriptionDisplayStatusToStatusDotUse,
    messageMap: subscriptionDisplayStatusToStatusBadgeMessage
  },
  commercePayment: {
    useMap: commercePaymentStatusToStatusDotUse,
    messageMap: commercePaymentStatusToMessage
  }
};
export function StatusLabel({
  status,
  domain
}) {
  const {
    useMap,
    messageMap
  } = STATUS_MAPS[domain];
  const key = readUnhandledEnumCase(status);
  const dotUse = key in useMap ? useMap[key] : undefined;
  const message = key in messageMap ? messageMap[key] : undefined;
  if (!dotUse || !message) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(StatusDot, {
      use: dotUse
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })]
  });
}